import Utils from "./libs/snake.lib.utils.js";
import Hook from "./libs/snake.lib.hook.js";
import Trace from "./libs/snake.lib.trace.js";
import Identity from "./libs/snake.lib.identity.js";
import Storage from "./libs/snake.lib.storage.js";
import AnalyticsService from "./libs/snake.lib.analytics.js";
import Validate from "./libs/snake.lib.validate.js";
import Component from "./component.js";
import config from "./config.js";

export default class ComponentAgent {
    static modalI18nGenericOptions;

    static init = async () => {
        Trace.debug("Component _cmpAgent");

        if (Identity.isAgent() || Identity.isAgentCustomer()) {
            Trace.debug("Component _cmpAgent isAgent");

            this.modalI18nGenericOptions = Component.getModalI18nGenericOptions();

            if (!Identity.isAuth()) {
                Trace.debug("Component _cmpAgent isAgent !isAuth");

                const componentDom = document.getElementById(config.routing.sections.agent.component);

                const form = componentDom.querySelector("form");

                if (!form.dataset.validationAttached) Validate.attach(form, (formIsValid) => (form.querySelector('button[type="submit"]').disabled = !formIsValid));

                Hook.attachListeners();

                /**
                 * Listener to intercept the agentGenerateEmail call on the Profile Create user action
                 */
                Hook.subscribe("_agentGenerateEmail", async (e) => {
                    const field = document.getElementById("sign-up-email");

                    field.value = "nomail." + window.snakeCheckout.currentCountry + ".publishing+" + (Math.floor(Math.random() * 999999999999) + 1) + "@deagostini.com";

                    field.focus();
                    field.blur();
                });

                /**
                 * Listener to intercept the agent User Search action
                 */
                Hook.subscribe("_agentSearch", async () => {
                    Utils.spinner("loader", true);

                    const formData = new FormData(form);

                    await Identity.agentSignIn(formData.get("agent-email-gigyaid"), formData.get("agent-secret"))
                        .then(async (response) => {
                            if (response.errorCode !== 0) {
                                Utils.modal("popup", true, { text: response.errorMessage });

                                AnalyticsService.errorEvent("1_login", "technical", "gproxy | sign-in response error", response);
                            } else {
                                Storage.set("agent_order", formData.get("agent-order-type"));

                                setTimeout(() => {
                                    window.location.reload();
                                }, 500);
                            }
                        })
                        .catch((e) => {
                            Utils.spinner("loader", false);

                            Utils.modal("popup", true, this.modalI18nGenericOptions);

                            AnalyticsService.errorEvent("1_login", "technical", "gproxy | sign-in error", e);
                        });
                });
            }

            Component.setCheckoutStepsVisibility([config.routing.sections.agent.component], true);
        } else {
            Storage.delete("agent_order");
            Component.setCheckoutStepsVisibility([config.routing.sections.agent.component], false);
        }
    };
}
